import React,{ Component } from 'react';
import { FormGroup, Label, Input, FormText, Modal, ModalBody, ModalHeader, Progress } from 'reactstrap';
import ImageCompressor from 'image-compressor.js';

export default class Upload extends Component{
    constructor(props){
        super(props);
        this.state = { error: false, lightbox: false, loading: false };
    }
    toggle = () => {
        this.setState((state) => ({...state, lightbox: !state.lightbox}));
    }
    setImage = async (event) => {
        const { target: { files } } = event;
        const { onChange } = this.props;
        const image = files[0];
        if(image){
            this.setState({loading: true});
            const size = image.size/1000000;
            const extension = image.type;
            if(size < 6 && /(jpg|png|gif|jpeg)$/ig.test(extension)){
                const imagecompressor = new ImageCompressor();
                try{
                    const result = await imagecompressor.compress(image, { quality: 0.6,maxWidth: 1024, convertSize: 1500000 });
                    const reader = new FileReader();
                    reader.readAsDataURL(result);
                    reader.onload = () => {
                        const {result: imageData} = reader;
                        this.setState({error:false, loading: false});
                        onChange(imageData);
                    }
                }catch(err){
                    this.setState({error: true, loading: false});
                }
            }else{
                this.setState({error: true, loading: false});
            }
        }
    }

    render(){
        const { image } = this.props;
        const { error, lightbox, loading } = this.state;
        const imageName = image.split("/").pop();
        const color = error ? "danger":"muted";
        return (
            loading? <Progress style={{margin:"7px"}} animated value="100" /> :
            <FormGroup>
                <Label for="image">
                    <span className="btn btn-primary mr-3">Upload Image</span>
                </Label>
                { image !== "" && imageName !== "default.jpg"? <img onClick={this.toggle} src={image} alt="Niggle Job" height="150px"/>: null }
                <Modal centered size="lg" autoFocus toggle={ this.toggle } keyboard={ false } isOpen={lightbox}>
                    <ModalHeader toggle={ this.toggle }></ModalHeader>
                    <ModalBody>
                        <img src={image} alt="Niggle Job" className="d-block img-fluid"/>
                    </ModalBody>
                </Modal>
                <Input type="file" id="image" hidden onChange={this.setImage}/>
                <FormText className={error ? "font-weight-bold":""} color={color}>
                    Allowed extensions: jpg, png, gif. Maximum size: 6MB.
                </FormText>
            </FormGroup>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Upload.js